var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"details-button display-flex flex-wrap",attrs:{"role":"button"}},_vm.$listeners),[_vm._m(0),_c('div',{staticClass:"flex-col-12 flex-centerize"},[_c('SIcon',{staticClass:"icon",attrs:{"name":'three-dot-menu',"height":"4","width":"14"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col-12 flex-centerize"},[_c('h3',{staticClass:"reg"},[_vm._v("Details")])])
}]

export { render, staticRenderFns }